/* esm.sh - d3-transition@3.0.1/src/transition/delay */
export * from "/*d3-transition@3.0.1/esnext/src/transition/delay.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/delay.mjs";
